import {jwtDecode} from 'jwt-decode';

export function getCurrentUserId() {
    const token = localStorage.getItem('token');
    if (!token) return null;

    const payload = parseJwt(token);
    return payload['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier'];
}

export function getToken() {
    return localStorage.getItem('token');
}

export function getCurrentUserRole() {
    const token = getToken();
    if (!token) return null;

    try {
        const decoded = jwtDecode(token);
        return decoded['http://schemas.microsoft.com/ws/2008/06/identity/claims/role'];
    } catch (e) {
        return null;
    }
}

export function parseJwt(token) {
    try {
        return JSON.parse(atob(token.split('.')[1]));
    } catch (e) {
        return null;
    }
}
